export default __webpack_public_path__ + "static/media/forestly-expl-nn-05_DE.a33bab52.png";